module.exports = __webpack_public_path__ + "static/media/tiss-claim-number.bd8696af.png";